<template>
  <div v-if="remainingSeconds > 0" class="fixed bottom-4 right-4 bg-yellow-100 text-black p-4 rounded-xl shadow-lg text-lg font-mono">
    ⏳ Session expires in <strong>{{ minutes }}m {{ seconds }}s</strong>
  </div>
  <div v-else class="fixed inset-0 flex items-center justify-center bg-red-900 text-white text-4xl font-bold z-50">
    🥾 You've been BOOTED!
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const remainingSeconds = ref(0)

let intervalId: any = null

const updateRemaining = () => {
  const expiry = localStorage.getItem('token_expires_at')
  if (!expiry) {
    remainingSeconds.value = 0
    return
  }

  const diff = (new Date(expiry).getTime() - Date.now()) / 1000
  remainingSeconds.value = Math.max(0, Math.floor(diff))

  if (remainingSeconds.value === 0) {
    auth.logout()
  }
}

onMounted(() => {
  updateRemaining()
  intervalId = setInterval(updateRemaining, 1000)
})

onUnmounted(() => {
  clearInterval(intervalId)
})

const minutes = computed(() => Math.floor(remainingSeconds.value / 60))
const seconds = computed(() => remainingSeconds.value % 60)
</script>
